import { api } from "../api/api";

export const projectApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: () => ({
                url: "/projects",
                method: "GET",
            }),
        }),
        addProject: builder.mutation({
            query: (data) => ({
                url: "/projects",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const project = await queryFulfilled;
                    // pessimistic update project
                    dispatch(
                        api.util.updateQueryData(
                            "getProjects",
                            undefined,
                            (draft) => {
                                draft.push(project?.data);
                            }
                        )
                    );
                } catch (error) {}
            },
        }),
        updateProjectPosition: builder.mutation({
            query: ({ id, position }) => ({
                url: `/projects/${id}`,
                method: "PATCH",
                body: {
                    position,
                },
            }),
        }),
        deleteProject: builder.mutation({
            query: (id) => ({
                url: `/projects/${id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    await queryFulfilled;
                    // pessimistic update (delete project)
                    dispatch(
                        api.util.updateQueryData(
                            "getProjects",
                            undefined,
                            (draft) => {
                                return draft.filter(
                                    (project) => project.id !== arg
                                );
                            }
                        )
                    );
                } catch (error) {}
            },
        }),
    }),
});

export const {
    useGetProjectsQuery,
    useAddProjectMutation,
    useUpdateProjectPositionMutation,
    useDeleteProjectMutation,
} = projectApi;
